import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of, forkJoin } from 'rxjs';
import * as GraphActions from './graph.action';
import { GraphService } from 'src/app/core/services/graph.service';
import { UserService } from 'src/app/core/services/user.service';
import * as UserDetailsActions from '../user/user.action';

@Injectable()
export class GraphApiEffects {
  constructor(private actions$: Actions, private userService: UserService, private graphService: GraphService) { }
  getGraphDetails$ = createEffect(() => this.actions$.pipe(
    ofType(GraphActions.GetGraphDetailsApiAction),
    mergeMap((action) => forkJoin([this.graphService.getUserDetails(action.email)])
      .pipe(
        map(response => (GraphActions.SuccessGetGraphDetailsApiAction({
          graphDetails: ({
            ...response[0],
          })
        }))
        ),
        catchError(error => {
          this.userService.setError(error);
          return of(UserDetailsActions.ErrorPostUserDetailsApiAction(error));
        })
      ))));
}
